import React from "react";
import "./Style.css";

function Loader() {
  return (
    <div className="loader loader1">
      <div>
        <div>
          <div>
            <div>
              <div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loader;
